(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-store-locator"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.store-locator-list-cta__form').forEach((form) => {
  const email = form.querySelector('[data-minted-list-email]');
  const submit = form.querySelector('[data-minted-list-submit]');
  const feedback = form.querySelector('[data-minted-list-feedback]');

  if (!email || !submit || !feedback) return;

  const updateState = () => {
    const value = email.value.trim();
    const isValid = value.length > 0 && email.checkValidity();
    submit.disabled = !isValid;
    feedback.textContent = value.length > 0 && !isValid ? 'Please enter a valid email address.' : '';
  };

  email.addEventListener('input', updateState);
  email.addEventListener('blur', updateState);
  form.addEventListener('submit', (event) => {
    updateState();
    if (submit.disabled) {
      event.preventDefault();
      email.focus();
    }
  });
  updateState();
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["minted-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const DEBUG_MEGA = typeof window !== 'undefined' && window.location && window.location.search.includes('debugMega');
  const debugMega = (...args) => {
    if (DEBUG_MEGA) {
      console.debug('[mega]', ...args);
    }
  };
  // Enable mega only on desktop (1200px = the header's desktop breakpoint; matches
  // the CSS that hides .hdr__nav--desktop / .mega below it)
  const desktopMQ = window.matchMedia('(min-width: 1200px)');

  // Resolve nav element directly (avoid misidentifying the nav as header)
  const nav = document.getElementById('minted-header-{{ section.id }}')
            || document.querySelector('header.minted-header .hdr__nav--desktop');
  debugMega('init', { navFound: !!nav, sectionId: '{{ section.id }}' });
  if (!nav) return;

  // Get all nav items
  const navItems = nav.querySelectorAll('.nav__item');

  // CRITICAL: Move all mega menu panels outside header to escape stacking context
  const megaPanels = document.querySelectorAll('.mega');
  debugMega('panels detected', {
    count: megaPanels.length,
    panels: Array.from(megaPanels).map((p) => ({
      id: p.id,
      inHeader: !!p.closest('header.minted-header'),
      hidden: p.hidden,
      display: window.getComputedStyle(p).display
    }))
  });

  megaPanels.forEach(megaPanel => {
    if (megaPanel.closest('header.minted-header')) {
      debugMega('moving panel outside header', megaPanel.id);
      const originalParent = megaPanel.parentElement;
      document.body.appendChild(megaPanel);
      megaPanel.setAttribute('data-moved-to-body', 'true');
      debugMega('panel moved', {
        originalParent: originalParent.tagName + '.' + originalParent.className,
        newParent: megaPanel.parentElement.tagName,
        panelId: megaPanel.id,
        zIndex: window.getComputedStyle(megaPanel).zIndex,
        position: window.getComputedStyle(megaPanel).position,
        display: window.getComputedStyle(megaPanel).display
      });
    }
  });

  // Debug helper
  if (DEBUG_MEGA) {
    window.checkMegaMenus = function() {
      const megas = document.querySelectorAll('.mega');
      console.debug('=== MEGA MENU DEBUG ===');
      console.debug('Total megas found:', megas.length);
      megas.forEach((mega, i) => {
        const styles = window.getComputedStyle(mega);
        console.debug(`Mega ${i} (${mega.id}):`, {
          parent: mega.parentElement?.tagName,
          movedToBody: mega.getAttribute('data-moved-to-body'),
          hidden: mega.hidden,
          display: styles.display,
          visibility: styles.visibility,
          opacity: styles.opacity,
          zIndex: styles.zIndex,
          position: styles.position,
          top: styles.top,
          left: styles.left
        });
      });
    };
  } else if (typeof window.checkMegaMenus !== 'undefined') {
    delete window.checkMegaMenus;
  }

  let openItem = null;
  let closeTimer = null;
  const CLOSE_DELAY = 260;
  const POINTER_BUFFER = 12;

  const pointerState = { x: Number.NEGATIVE_INFINITY, y: Number.NEGATIVE_INFINITY };
  document.addEventListener('pointermove', (event) => {
    pointerState.x = event.clientX;
    pointerState.y = event.clientY;
  }, { passive: true });

  function getPanelForItem(item) {
    if (!item) return null;
    const triggerEl = item.querySelector('.js-mega-trigger');
    const panelId = triggerEl?.getAttribute('data-mega-target');
    return panelId ? document.getElementById(panelId) : null;
  }

  function pointerWithinMega(item) {
    if (!item) return false;
    const triggerEl = item.querySelector('.js-mega-trigger');
    const panel = getPanelForItem(item);
    const regions = [triggerEl, panel];

    return regions.some(region => {
      if (!region) return false;
      const rect = region.getBoundingClientRect();
      const expanded = {
        top: rect.top - POINTER_BUFFER,
        right: rect.right + POINTER_BUFFER,
        bottom: rect.bottom + POINTER_BUFFER,
        left: rect.left - POINTER_BUFFER
      };
      return pointerState.x >= expanded.left &&
             pointerState.x <= expanded.right &&
             pointerState.y >= expanded.top &&
             pointerState.y <= expanded.bottom;
    });
  }

  function scheduleClose(item) {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => {
      if (!desktopMQ.matches) return;
      if (openItem !== item) return;
      if (pointerWithinMega(item)) {
        scheduleClose(item);
        return;
      }
      closeMega(item, false);
    }, CLOSE_DELAY);
  }

  function setPanelTop(panel, triggerEl) {
    const hdr = document.querySelector('header.minted-header');
    const headerRect = hdr ? hdr.getBoundingClientRect() : { bottom: 80 };
    const trigRect = triggerEl ? triggerEl.getBoundingClientRect() : null;
    const gapPx = 4; // small gap below the trigger text
    const base = trigRect ? trigRect.bottom : headerRect.bottom;
    const topPx = Math.max(0, Math.round(base + gapPx));
    panel.style.top = topPx + 'px';
    debugMega('setPanelTop', { headerBottom: headerRect.bottom, trigBottom: trigRect?.bottom, topPx, z: getComputedStyle(panel).zIndex });
  }

  function openMega(item) {
    if (openItem && openItem !== item) closeMega(openItem, false);
    const trigger = item.querySelector('.js-mega-trigger');
    const panelId = trigger?.getAttribute('data-mega-target');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;
    debugMega('openMega', { panelId, hasPanel: !!panel });

    // Balance columns before showing
    balanceColumns(panel);

    // Position panel just below fixed header, and recalc once on first scroll
    setPanelTop(panel, trigger);
    window.addEventListener('scroll', () => setPanelTop(panel, trigger), { passive: true, once: true });

    panel.hidden = false;

    // Force display style when panel is moved to body
    if (panel.getAttribute('data-moved-to-body') === 'true') {
      panel.style.display = 'block';
      panel.style.visibility = 'visible';
      panel.style.opacity = '1';
      debugMega('forcing panel visibility', panel.id);
    }

    trigger.setAttribute('aria-expanded', 'true');
    item.classList.add('is-open');
    openItem = item;
    document.body.setAttribute('data-mega-open', 'true');
    if (DEBUG_MEGA) {
      const rect = panel.getBoundingClientRect();
      debugMega('panel visible', rect);
    }
  }

  // Function to balance columns when they exceed 8 items
  function balanceColumns(megaMenu) {
    const cols = megaMenu.querySelectorAll('.mega__col');
    const maxItemsPerCol = 8;

    // Process each column (2nd-level item)
    cols.forEach((col, colIndex) => {
      const thirdLevelItems = col.querySelectorAll('.mega__list li');
      if (thirdLevelItems.length > maxItemsPerCol) {
        // Get the 2nd-level heading
        const heading = col.querySelector('.mega__heading');
        const headingText = heading ? heading.textContent : 'More';
        const headingUrl = heading ? heading.href : '#';

        // Keep first 8 items in current column
        const itemsToKeep = Array.from(thirdLevelItems).slice(0, maxItemsPerCol);
        const itemsToMove = Array.from(thirdLevelItems).slice(maxItemsPerCol);

        // Clear current column and add only the first 8 items
        const currentList = col.querySelector('.mega__list');
        currentList.innerHTML = '';
        itemsToKeep.forEach(item => {
          currentList.appendChild(item);
        });

        // Create new column for overflow items (no heading, just the list)
        const newCol = document.createElement('div');
        newCol.className = 'mega__col mega__col--overflow';
        newCol.innerHTML = `
          <ul class="mega__list" role="list"></ul>
        `;

        const newColList = newCol.querySelector('.mega__list');
        itemsToMove.forEach(item => {
          newColList.appendChild(item);
        });

        // Insert new column after current column
        col.parentNode.insertBefore(newCol, col.nextSibling);

        // Move all subsequent columns to the right
        const allCols = megaMenu.querySelectorAll('.mega__col');
        for (let i = colIndex + 2; i < allCols.length; i++) {
          const nextCol = allCols[i];
          if (nextCol && nextCol !== newCol) {
            col.parentNode.insertBefore(nextCol, newCol.nextSibling);
          }
        }
      }
    });
  }

  function closeMega(item, focusTrigger) {
    const trigger = item.querySelector('.js-mega-trigger');
    const panelId = trigger?.getAttribute('data-mega-target');
    const panel = panelId && document.getElementById(panelId);
    if (!panel) return;
    clearTimeout(closeTimer);
    panel.hidden = true;

    // Force hide when panel is moved to body
    if (panel.getAttribute('data-moved-to-body') === 'true') {
      panel.style.display = 'none';
    }

    trigger.setAttribute('aria-expanded', 'false');
    item.classList.remove('is-open');
    if (focusTrigger) trigger.focus();
    if (openItem === item) openItem = null;
    document.body.removeAttribute('data-mega-open');
  }

  function addItemHandlers(item) {
    const trigger = item.querySelector('.js-mega-trigger');
    const panelId = trigger?.getAttribute('data-mega-target');
    const panel = panelId && document.getElementById(panelId);
    const hasPanel = !!panel;
    if (DEBUG_MEGA) console.debug('[mega] bind item:', { hasPanel, panelId, text: trigger?.textContent?.trim() });

    // Only add hover/focus handlers if there's a panel
    if (hasPanel) {
      // Hover/focus open
      item.addEventListener('mouseenter', () => {
        if (!desktopMQ.matches) return;
        clearTimeout(closeTimer);
        openMega(item);
      });
      item.addEventListener('mouseleave', () => {
        if (!desktopMQ.matches) return;
        scheduleClose(item);
      });
      trigger.addEventListener('focus', () => {
        if (!desktopMQ.matches) return;
        openMega(item);
      });
      trigger.addEventListener('blur', (event) => {
        if (!desktopMQ.matches) return;
        const related = event.relatedTarget;
        if (related && (item.contains(related) || getPanelForItem(item)?.contains(related))) {
          return;
        }
        scheduleClose(item);
      });
      // Click to open as a fallback on desktop
      trigger.addEventListener('click', (e) => {
        if (!desktopMQ.matches) return; // allow mobile nav behavior
        e.preventDefault();
        openMega(item);
      });

      // Keep open when moving cursor into panel; close when leaving panel
      panel.addEventListener('mouseenter', () => {
        if (!desktopMQ.matches) return;
        clearTimeout(closeTimer);
      });
      panel.addEventListener('mouseleave', () => {
        if (!desktopMQ.matches) return;
        scheduleClose(item);
      });
      panel.addEventListener('focusin', () => {
        if (!desktopMQ.matches) return;
        clearTimeout(closeTimer);
        openMega(item);
      });
      panel.addEventListener('focusout', (event) => {
        if (!desktopMQ.matches) return;
        const related = event.relatedTarget;
        if (related && panel.contains(related)) return;
        scheduleClose(item);
      });
    }

    // Keyboard (always add for navigation)
    item.addEventListener('keydown', (e) => {
      if (!desktopMQ.matches) return;
      if (e.key === 'Escape' && openItem === item) { e.preventDefault(); closeMega(item, true); }
      if ((e.key === 'ArrowRight' || e.key === 'ArrowLeft')) {
        // Move focus between top-level triggers
        e.preventDefault();
        const items = Array.from(nav.querySelectorAll('.nav__item .js-mega-trigger'));
        const idx = items.indexOf(trigger);
        const dir = e.key === 'ArrowRight' ? 1 : -1;
        const next = items[(idx + dir + items.length) % items.length];
        next?.focus();
      }
    });

    // Click outside to close (only add once)
    if (item === nav.querySelector('.nav__item:first-child')) {
      document.addEventListener('click', (e) => {
        if (!openItem || !desktopMQ.matches) return;
        if (!openItem.contains(e.target)) closeMega(openItem, false);
      });
    }
  }

  function enableDesktop() {
    // Close any open panel when switching modes
    if (openItem) closeMega(openItem, false);

    nav.querySelectorAll('.nav__item').forEach(addItemHandlers);

    // Recalculate top on resize for open panel
    const onResize = () => {
      if (!openItem) return;
      const trigger = openItem.querySelector('.js-mega-trigger');
      const panelId = trigger?.getAttribute('data-mega-target');
      const panel = panelId && document.getElementById(panelId);
      if (panel) setPanelTop(panel, trigger);
    };
    window.addEventListener('resize', onResize, { passive: true });

    // Delegated hover/focus as a fallback to ensure behavior on homepage
    const delegatedOver = (e) => {
      if (!desktopMQ.matches) return;
      const item = e.target.closest('.nav__item');
      if (!item || !nav.contains(item)) return;
      clearTimeout(closeTimer);
      openMega(item);
    };
    const delegatedOut = (e) => {
      if (!desktopMQ.matches) return;
      const item = e.target.closest('.nav__item');
      if (!item || !nav.contains(item)) return;
      // If moving into the currently open panel, do not schedule close
      const to = e.relatedTarget;
      if (openItem) {
        const trg = openItem.querySelector('.js-mega-trigger');
        const pid = trg?.getAttribute('data-mega-target');
        const pnl = pid && document.getElementById(pid);
        if (pnl && pnl.contains(to)) return;
      }
      scheduleClose(item);
    };
    document.addEventListener('mouseover', delegatedOver);
    document.addEventListener('mouseout', delegatedOut);
    document.addEventListener('focusin', delegatedOver);

    // Ultimate fallback: emulate hover using mousemove over header band (handles invisible overlays)
    let raf = null;
    const onMove = (e) => {
      if (!desktopMQ.matches) return;
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const hdr = document.querySelector('header.minted-header');
        if (!hdr) return;
        const headerRect = hdr.getBoundingClientRect();
        const x = e.clientX; const y = e.clientY;
        // Only when pointer is within header band
        if (y < headerRect.top || y > headerRect.bottom) return;
        const triggers = Array.from(nav.querySelectorAll('.js-mega-trigger'));
        for (const t of triggers) {
          const r = t.getBoundingClientRect();
          if (x >= r.left && x <= r.right && y >= headerRect.top && y <= headerRect.bottom) {
            const item = t.closest('.nav__item');
            if (item) openMega(item);
            break;
          }
        }
      });
    };
    document.addEventListener('mousemove', onMove, { passive: true });
  }

  function disableDesktop() {
    if (openItem) closeMega(openItem, false);
    // Panels stay hidden on mobile; drawer handles nav there
  }

  desktopMQ.addEventListener ? desktopMQ.addEventListener('change', e => e.matches ? enableDesktop() : disableDesktop())
                              : desktopMQ.addListener(e => e.matches ? enableDesktop() : disableDesktop());

  // init
  desktopMQ.matches ? enableDesktop() : disableDesktop();
});

/*
 * Account sheet brand decoration (2026-09-03 owner request): Minted mark beside
 * the sheet heading, heading in brand green, icons on the menu links.
 *
 * OFF-API: Shopify's <shopify-account> exposes only CSS variables and two parts;
 * this reaches into its OPEN shadow root and keys on internal class names
 * (.account__heading, .account__item). Shopify may rename or close these at any
 * time. Everything below is feature-detected and idempotent, so if the internals
 * change the sheet simply renders undecorated — it never breaks.
 */
(function () {
  const GREEN = 'var(--minted-green, #1b7548)';
  const SVG = 'http://www.w3.org/2000/svg';

  // Minted mark: first <g> of assets/Minted-logo-web-dark.svg, fill -> currentColor.
  const MARK_PATHS = [
    'M43.33,83.12l23.3,75.34c.6,2,2.61,3.21,4.66,2.8l17.24-3.46-2.65-6.62-10.82,2.17c-1.41.28-2.8-.55-4.34-4.49l-22.75-73.38-4.65,7.64Z',
    'M113.09,160.01c.69-1.35.8-2.95.21-4.4L51.38,2.01c-.49-1.21-1.67-2.01-2.98-2.01h-7.35c-1.18,0-2.26.64-2.82,1.68L.69,70.73c-.74,1.32-.89,2.89-.44,4.34l50.86,138.64c.31.99,1.06,1.65,1.93,1.92l.76.13c.8.04,1.62-.24,2.25-.89l36.39-33.7,20.29-20.36c.23-.23.34-.51.36-.79ZM10.62,72.09l29.92-54.43,7.75,19.37-31.3,52.14-6.37-17.08ZM56.84,200.7L20.22,99.41l32.47-51.34,45.02,112.59-40.88,40.04Z',
    'M128.65,141.51l-11.31,2.99,2.58,6.39,15.69-3.39c2.52-.51,4.07-3.06,3.35-5.53l-26.52-90.78c-.64-2.2-2.82-3.58-5.08-3.21l-26.75,5.38,2.72,6.74,20.78-4.17c1.29-.26,2.56.51,2.92,1.77l23.41,80.73c.39,1.35-.42,2.75-1.79,3.07Z',
    'M163.31,150.1L146.39,3.72c-.38-3.26-4.18-4.85-6.76-2.82l-49.74,39,19.78-5.09,23.82-17.65,15.71,133.33-48.98,43.93,1.13,9.11c.23,1.82,2.4,2.64,3.77,1.42l56.3-49.92c1.39-1.24,2.1-3.07,1.9-4.92Z'
  ];

  // Outline icons (24px grid, stroke 2) keyed by menu label; href path is the fallback key.
  const MENU_ICONS = {
    'orders':    { d: 'M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4zM3 6h18M16 10a4 4 0 0 1-8 0' },
    'profile':   { d: 'M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2', circle: [12, 7, 4] },
    'my events': { d: 'M16 2v4M8 2v4M3 10h18M9 15l2 2 4-4', rect: [3, 4, 18, 18, 2] },
    'my points': { d: 'M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z' }
  };
  const HREF_KEYS = [[/\/orders(\?|$)/, 'orders'], [/\/profile(\?|$)/, 'profile']];

  function el(tag, attrs) {
    const node = document.createElementNS(SVG, tag);
    for (const k in attrs) node.setAttribute(k, attrs[k]);
    return node;
  }

  function markSvg() {
    const svg = el('svg', { class: 'minted-acct-glyph', viewBox: '0 0 164 216', 'aria-hidden': 'true', focusable: 'false' });
    MARK_PATHS.forEach((d) => svg.appendChild(el('path', { d, fill: 'currentColor' })));
    return svg;
  }

  function iconSvg(spec) {
    const svg = el('svg', {
      class: 'minted-acct-icon', viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor',
      'stroke-width': '2', 'stroke-linecap': 'round', 'stroke-linejoin': 'round',
      'aria-hidden': 'true', focusable: 'false'
    });
    if (spec.rect) {
      const [x, y, w, h, rx] = spec.rect;
      svg.appendChild(el('rect', { x, y, width: w, height: h, rx }));
    }
    if (spec.circle) {
      const [cx, cy, r] = spec.circle;
      svg.appendChild(el('circle', { cx, cy, r }));
    }
    svg.appendChild(el('path', { d: spec.d }));
    return svg;
  }

  function iconKeyFor(link) {
    const label = (link.textContent || '').trim().toLowerCase();
    if (MENU_ICONS[label]) return label;
    const href = link.getAttribute('href') || '';
    const hit = HREF_KEYS.find(([re]) => re.test(href.split('?')[0]));
    return hit ? hit[1] : null;
  }

  function ensureStyle(root) {
    if (root.querySelector('style[data-minted-acct]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-minted-acct', '');
    style.textContent =
      // !important: the component's own rules outrank ours on specificity.
      // Heading (owner ruling 2026-09-03): Minted mark stacked ABOVE the heading text, both
      // centered across the sheet. Shopify's header is a [1fr auto] grid (content | close);
      // we collapse it to a block and float the close button top-right so the centre is true.
      // Scoped to :not(.three-column) so the back-button header on later steps keeps its layout.
      '.account__header:not(.three-column){display:block !important;}' +
      '.account__header:not(.three-column) .account__header-content{align-items:center;text-align:center;padding:6px 36px 2px !important;}' +
      '.account__header:not(.three-column) .account__heading{flex-direction:column;justify-content:center;gap:8px;}' +
      '.account__heading{color:' + GREEN + ' !important;font-size:16px !important;line-height:1.15 !important;letter-spacing:-0.02em !important;}' +
      '.minted-acct-glyph{width:40px;height:52px;flex:none;margin:0;color:' + GREEN + ' !important;}' +
      // Close button: no grey box, glyph in brand green; faint green wash on hover only.
      '.account__close{position:absolute !important;top:12px;right:12px;background:transparent !important;box-shadow:none !important;color:' + GREEN + ' !important;}' +
      '.account__close:hover{background:rgba(27,117,72,.08) !important;}' +
      '.account__close svg{width:22px !important;height:22px !important;}' +
      // Icon size needs !important: Shopify's own `.account__item svg { width: var(--size-icon-sm) }`
      // (20px) outranks the class rule in its adopted sheets — without it the icons render 20px.
      '.account__item svg.minted-acct-icon,.minted-acct-icon{width:32px !important;height:32px !important;flex:none !important;color:' + GREEN + ' !important;stroke:' + GREEN + ' !important;transition:transform .22s cubic-bezier(.2,.8,.2,1);}' +
      // Mobile sheet presentation (owner ruling 2026-09-03): Shopify pins the dialog to the
      // bottom edge, full-bleed, at <=767px. We re-anchor it to the top as a floating card with
      // 12px margins (safe-area aware), all corners rounded, and swap the slide-up keyframes
      // for a drop-in/out. The component's own rules are in adoptedStyleSheets, which cascade
      // after this <style>, so every declaration here needs !important. Undo: delete this block.
      '@keyframes minted-sheet-drop-in{0%{transform:translateY(-28px);opacity:0}100%{transform:translateY(0);opacity:1}}' +
      '@keyframes minted-sheet-drop-out{0%{transform:translateY(0);opacity:1}100%{transform:translateY(-28px);opacity:0}}' +
      // Desktop: right edge follows the header icon cluster (set by alignToContent) instead of
      // the viewport edge, so the popover stays inside the content column on wide screens.
      '@media (min-width:768px){.dialog{inset-inline-end:var(--minted-sheet-right,20px) !important;}}' +
      '@media (max-width:767px){' +
        '.dialog{--dialog-drawer-opening-animation:minted-sheet-drop-in !important;--dialog-drawer-closing-animation:minted-sheet-drop-out !important;--dialog-drawer-easing:cubic-bezier(.2,.8,.2,1) !important;inset:max(12px,env(safe-area-inset-top)) 12px auto 12px !important;width:auto !important;max-width:none !important;border-radius:var(--shopify-account-radius-dialog) !important;max-height:calc(100dvh - 24px) !important;box-shadow:0 18px 48px rgba(23,61,42,.28) !important;}' +
        '.dialog .account{max-height:calc(100dvh - 24px) !important;}' +
      '}' +
      // Menu as a 2x2 grid of neumorphic tiles (owner request 2026-09-03): icon above bold
      // label, soft raised shadows. Mobile-first motion: the PRESS is the primary feedback
      // (fast sink into an inset shadow, springs back on release); hover-lift exists only for
      // real pointers (hover:hover + pointer:fine) so touch never gets a stuck hover state.
      // No tap-highlight flash, no double-tap zoom delay, keyboard focus ring, all motion off
      // under prefers-reduced-motion. No outer stroke, no dividers.
      '.account__shortcuts{display:grid !important;grid-template-columns:1fr 1fr;gap:22px;border:0 !important;background:transparent !important;padding:8px 6px 14px !important;}' +
      '.account__item-wrapper{border:0 !important;border-radius:16px !important;overflow:visible !important;}' +
      '.account__item-wrapper::before,.account__item-wrapper::after{display:none !important;content:none !important;}' +
      // Vertical centring (owner 2026-09-03): symmetric padding, and the label must NOT stretch —
      // Shopify's `.account__item-text { flex: 1 1 0% }` was filling the tile's leftover height
      // so the word sat at the top of a tall box. Icon 32px, gap 8px, label 15px.
      '.account__item{flex-direction:column !important;align-items:center !important;justify-content:center !important;gap:8px !important;min-height:96px;padding:16px 10px !important;border-radius:16px !important;background:#eef4f0 !important;box-shadow:8px 8px 18px rgba(23,61,42,.22),-8px -8px 18px #fff,inset 1px 1px 0 rgba(255,255,255,.9) !important;color:#173d2a !important;text-align:center;outline:none;-webkit-tap-highlight-color:transparent;touch-action:manipulation;user-select:none;-webkit-user-select:none;transform:translateY(0) scale(1);transition:transform .26s cubic-bezier(.2,.8,.2,1),box-shadow .26s cubic-bezier(.2,.8,.2,1),background-color .26s ease !important;}' +
      '.account__item:active{transform:translateY(1px) scale(.96);transition-duration:.07s !important;background:#e6efe9 !important;box-shadow:inset 5px 5px 12px rgba(23,61,42,.24),inset -5px -5px 12px #fff !important;}' +
      '.account__item:active .minted-acct-icon{transform:scale(.92);transition-duration:.07s;}' +
      '@media (hover:hover) and (pointer:fine){' +
        '.account__item:hover{transform:translateY(-3px) scale(1.02);background:#f3f8f5 !important;box-shadow:11px 11px 24px rgba(23,61,42,.26),-10px -10px 22px #fff,inset 1px 1px 0 rgba(255,255,255,.95) !important;}' +
        '.account__item:hover .minted-acct-icon{transform:translateY(-2px) scale(1.1);}' +
        '.account__item:hover:active{transform:translateY(1px) scale(.96);background:#e6efe9 !important;box-shadow:inset 5px 5px 12px rgba(23,61,42,.24),inset -5px -5px 12px #fff !important;}' +
        '.account__item:hover:active .minted-acct-icon{transform:scale(.92);}' +
      '}' +
      '.account__item:focus-visible{box-shadow:8px 8px 18px rgba(23,61,42,.22),-8px -8px 18px #fff,0 0 0 3px rgba(23,61,42,.35) !important;}' +
      '@media (prefers-reduced-motion:reduce){.account__item,.minted-acct-icon{transition:none !important;}.account__item:hover,.account__item:hover .minted-acct-icon,.account__item:active,.account__item:active .minted-acct-icon{transform:none !important;}}' +
      '.account__item-text{flex:0 0 auto !important;min-width:0;max-width:100%;font-weight:700 !important;font-size:15px !important;line-height:1.2 !important;}' +
      // Menu links only for signed-in customers (owner ruling 2026-09-03). Shopify shows them
      // to everyone by design; we hide the region while the sheet is in its sign-in state.
      ':host([data-minted-menu="hidden"]) .account__menu-region{display:none !important;}';
    root.appendChild(style);
  }

  /* Signed-out = Liquid saw no customer AND the sheet is showing its login form.
     Checking the form too means the menu appears right after an in-sheet sign-in,
     without waiting for a reload; an unknown structure defaults to SHOWING the menu. */
  function syncMenuVisibility(root) {
    const host = root.host;
    if (!host) return;
    const liquidSignedIn = host.getAttribute('data-signed-in') === 'true';
    const loginFormShown = !!root.querySelector('.account__login-slot shopify-login-form, .account__login-slot shop-login');
    const hide = !liquidSignedIn && loginFormShown;
    if (host.getAttribute('data-minted-menu') !== (hide ? 'hidden' : 'shown')) {
      host.setAttribute('data-minted-menu', hide ? 'hidden' : 'shown');
    }
  }

  function decorate(root) {
    ensureStyle(root);
    syncMenuVisibility(root);
    root.querySelectorAll('.account__heading').forEach((h) => {
      if (!h.querySelector('.minted-acct-glyph')) h.insertBefore(markSvg(), h.firstChild);
    });
    root.querySelectorAll('.account__item').forEach((a) => {
      if (a.querySelector('.minted-acct-icon')) return;
      const key = iconKeyFor(a);
      if (key) a.insertBefore(iconSvg(MENU_ICONS[key]), a.firstChild);
    });
  }

  function attach(component) {
    if (component.__mintedDecorated) return;
    const root = component.shadowRoot;
    if (!root) return; // closed shadow root or not yet upgraded: nothing to do
    component.__mintedDecorated = true;
    // iOS Safari only applies :active on touch when a touchstart listener exists in the tree.
    // A passive no-op on the shadow root makes the tile press feedback fire reliably.
    root.addEventListener('touchstart', function () {}, { passive: true });
    let queued = false;
    const run = () => { queued = false; decorate(root); };
    decorate(root);
    new MutationObserver(() => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(run);
    }).observe(root, { childList: true, subtree: true });
  }

  // Desktop placement (owner ruling 2026-09-03): Shopify pins the popover to the VIEWPORT's
  // right edge, so on wide screens it lands in the gutter beside the content. We measure the
  // header's .container and hand its right-edge offset to the dialog as a custom property
  // (inherited through the shadow boundary). Re-measured on open and on resize.
  let probe = null;
  function fixedRightEdge() {
    // The dialog is position:fixed; its containing block excludes the scrollbar, which
    // clientWidth/innerWidth may not. A fixed probe gives the edge the dialog actually uses.
    if (!probe) {
      probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;top:0;right:0;width:1px;height:1px;visibility:hidden;pointer-events:none';
      document.body.appendChild(probe);
    }
    return probe.getBoundingClientRect().right;
  }

  function alignToContent(component) {
    // Align the popover's right edge with the header icon cluster (the content's visual edge).
    const edge = component.closest('.minted-header__icons') || component.closest('.container') || document.querySelector('.minted-header .container');
    if (!edge) return;
    const right = Math.max(0, Math.round(fixedRightEdge() - edge.getBoundingClientRect().right));
    component.style.setProperty('--minted-sheet-right', right + 'px');
  }

  function init() {
    const all = document.querySelectorAll('shopify-account');
    all.forEach((c) => {
      attach(c);
      alignToContent(c);
      c.addEventListener('open', () => { attach(c); alignToContent(c); }); // documented event; shadow root exists by now
    });
    if (all.length && !window.__mintedSheetResize) {
      window.__mintedSheetResize = true;
      window.addEventListener('resize', () => all.forEach(alignToContent), { passive: true });
    }
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('shopify-account').then(init, init);
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
})();

  } catch(e) { console.error(e); }
})();
})();
